/**
 * Describes different types of events
 */
export default Object.freeze({
  Unknown: 'Unknown',
  PD: 'PD',
  Other: 'Other',
  UkInfo: 'UkInfo',
})
